import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import './style.scss';
import {getRouting} from '../../../../../utils/common';

class Actions extends Component {
    constructor(props){
        super(props);
    }

    createActionNav = (nav, index) => {
        return (
            <li key={index}>
                <Link to={getRouting(nav.routeConstant)}>
                    <i className={nav.attributes && nav.attributes.class}></i>
                    <span className='title-icon'>{nav.linkName}</span>
                </Link>
            </li>
        )
    };

    render() {
        const {actionsNav} = this.props;

        return (
            <ul className='actions-nav clearfix'>
                {actionsNav && actionsNav.length && actionsNav.map(this.createActionNav)}
            </ul>
        );
    }
}

export default Actions;
